import * as React from "react";

import { AmendReportProps } from "../../model";
import { TaskActionButton } from "../TaskActionButton";

export const QAAmendMHPTreatmentReportButton: React.FunctionComponent<AmendReportProps> = (props: AmendReportProps) => {
    if (!props.task.completed) {
        return (
            <TaskActionButton
                task={props.task}
                customerId={props.customerId}
                content="Amend MHP Treatment Report"
                taskRoute="qaAmendMHPTreatmentReport"
            />
        );
    }
    return (
        <TaskActionButton
            task={props.task}
            customerId={props.customerId}
            content="View Amend MHP Treatment Report"
            taskRoute="mhpTreatmentReport"
        />
    );
};
